import { render, staticRenderFns } from "./YearButtonPad.vue?vue&type=template&id=1ff4cd16&scoped=true&"
import script from "./YearButtonPad.vue?vue&type=script&lang=js&"
export * from "./YearButtonPad.vue?vue&type=script&lang=js&"
import style0 from "./YearButtonPad.vue?vue&type=style&index=0&id=1ff4cd16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4cd16",
  null
  
)

export default component.exports